/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboPostwizercompanyPostWizerCompanyRequestBody
 */
export interface JumboPostwizercompanyPostWizerCompanyRequestBody {
    /**
     * 
     * @type {string}
     * @memberof JumboPostwizercompanyPostWizerCompanyRequestBody
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof JumboPostwizercompanyPostWizerCompanyRequestBody
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof JumboPostwizercompanyPostWizerCompanyRequestBody
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof JumboPostwizercompanyPostWizerCompanyRequestBody
     */
    lastName: string;
}

/**
 * Check if a given object implements the JumboPostwizercompanyPostWizerCompanyRequestBody interface.
 */
export function instanceOfJumboPostwizercompanyPostWizerCompanyRequestBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "companyName" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;

    return isInstance;
}

export function JumboPostwizercompanyPostWizerCompanyRequestBodyFromJSON(json: any): JumboPostwizercompanyPostWizerCompanyRequestBody {
    return JumboPostwizercompanyPostWizerCompanyRequestBodyFromJSONTyped(json, false);
}

export function JumboPostwizercompanyPostWizerCompanyRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboPostwizercompanyPostWizerCompanyRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyName': json['companyName'],
        'email': json['email'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
    };
}

export function JumboPostwizercompanyPostWizerCompanyRequestBodyToJSON(value?: JumboPostwizercompanyPostWizerCompanyRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companyName': value.companyName,
        'email': value.email,
        'firstName': value.firstName,
        'lastName': value.lastName,
    };
}

